import React from "react";
import { Link } from "gatsby";
import { slug } from "../utils";
import { parseURL } from "./tailwind/portableText";
import { Link as LinkScroll } from "react-scroll";

// Parse file URL from Sanity reference
const parseFileURL = (ref) => {
  if (!ref) return "";

  // Handle format: "file-[hash]-[extension]"
  // Example: "file-4ee1b45f2495c516063efacc13ed940508c3d1e8-pdf"
  const regex = /^file-([a-zA-Z0-9]+)-(\w+)$/;
  const match = ref.match(regex);

  if (match) {
    const fileId = match[1];
    const extension = match[2];
    return `https://cdn.sanity.io/files/eo9g5l50/production/${fileId}.${extension}`;
  }

  // Fallback to the original method for other formats
  const split = ref.split("-");
  if (split.length >= 4) {
    const fileId = split[1];
    const extension = split[split.length - 1];
    // Reconstruct the file name from the remaining parts
    const fileName = split.slice(2, split.length - 1).join("-");
    return `https://cdn.sanity.io/files/eo9g5l50/production/${fileId}-${fileName}.${extension}`;
  }

  return "";
};

const Button = ({
  text,
  btnType,
  linkType,
  link,
  pdf,
  cls = "",
  border = "bordered-white",
  submit = false,
  disable = false,
}) => {
  if (linkType === "internal") {
    return (
      <Link
        to={slug(link)}
        className={`main-btn ${cls} ${
          btnType === "primary" ? "btn-yellow" : `bordered-btn ${border}`
        } `}
      >
        {text}
      </Link>
    );
  } else if (linkType === "external") {
    return (
      <a
        href={link}
        className={`main-btn ${cls} ${
          btnType === "primary" ? "btn-yellow" : `bordered-btn ${border}`
        } `}
        target="_blank"
      >
        {text}
      </a>
    );
  } else if (linkType === "upload") {
    if (pdf?.asset?._ref) {
      return (
        <a
          href={parseFileURL(pdf?.asset?._ref)}
          className={`main-btn ${cls} ${
            btnType === "primary" ? "btn-yellow" : `bordered-btn ${border}`
          } `}
          target="_blank"
          rel="noopener noreferrer"
        >
          {text}
        </a>
      );
    }
    return (
      <a
        href={pdf?.asset?.url}
        className={`main-btn ${cls} ${
          btnType === "primary" ? "btn-yellow" : `bordered-btn ${border}`
        } `}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </a>
    );
  } else if (linkType === "id") {
    return (
      <LinkScroll
        to={link}
        smooth={true}
        offset={0}
        style={{
          cursor: "pointer",
        }}
        className={`main-btn cursor-pointer ${cls} ${
          btnType === "primary" ? "btn-yellow" : "bordered-btn bordered-white"
        } `}
      >
        {text}
      </LinkScroll>
    );
  } else {
    return (
      <button
        className={`main-btn ${cls} ${
          btnType === "primary" ? "btn-yellow" : "bordered-btn bordered-white"
        } `}
        type={submit ? "submit" : "button"}
        disabled={disable}
      >
        {text}
      </button>
    );
  }
};

export default Button;
